<template>
    <div class="sidebar" :data-color="activeColor" :style="sidebarStyle">
        <div class="logo">
            <a href="#" class="simple-text logo-mini">
                <div class="logo-img">
                <img :src="imgLogo" alt="" />
                </div>
            </a>

            <a href="/" class="simple-text logo-normal">{{ title }}</a>
        </div>
        <div class="sidebar-wrapper">
            <slot name="content"></slot>
            <md-list class="nav">
                <!--By default vue-router adds an active class to each route link. This way the links are colored when clicked-->
                <slot>
                    <sidebar-link v-for="(link, index) in sidebarLinks" :key="link.name + index" :to="link.path" :link="link"></sidebar-link>
                </slot>
            </md-list>
            <div class="sidebar-footer">
                <md-list class="nav">
                    <sidebar-link key="logout" to="logout" :link="{name: 'Logout', icon: 'exit_to_app'}"></sidebar-link>
                </md-list>
            </div>
        </div>
    </div>
</template>

<script>
import SidebarLink from "./SidebarLink.vue";

export default {
    components: {
        SidebarLink
    },
    props: {
        title: {
            type: String,
            default: "PM-tool"
        },
        backgroundImage: {
            type: String,
            default: require("@/assets/img/sidebar-2.jpg")
        },
        imgLogo: {
            type: String,
            default: require("@/assets/img/newance-logo-small.svg")
        },
        activeColor: {
            type: String,
            default: "blue",
            validator: value => {
                let acceptedValues = ["", "purple", "blue", "green", "orange", "red"];
                return acceptedValues.indexOf(value) !== -1;
            }
        },
        sidebarLinks: {
            type: Array,
            default: () => []
        },
        autoClose: {
            type: Boolean,
            default: true
        }
    },
    provide() {
        return {
            autoClose: this.autoClose
        };
    },
    computed: {
        sidebarStyle() {
            return {
                backgroundColor: "#459FFF"
                // backgroundImage: `url(${this.backgroundImage})`
            };
        }
    }
};
</script>

<style>
@media screen and (min-width: 991px) {
    .nav-mobile-menu {
        display: none;
    }
}
</style>
